import securedAxios from '~/javascript/utils/axios'

const api = securedAxios()

export async function fetchGyms(params = {}) {
  const response = await api.get('/admin/gyms.json', { params })
  return response.data
}

export async function fetchGym(id) {
  const response = await api.get(`/admin/gyms/${id}.json`)
  return response.data
}

export async function createGym(gymData) {
  const response = await api.post('/admin/gyms.json', { gym: gymData })
  return response.data
}

export async function updateGym(id, gymData) {
  const response = await api.patch(`/admin/gyms/${id}.json`, { gym: gymData })
  return response.data
}

export async function deleteGym(id) {
  const response = await api.delete(`/admin/gyms/${id}.json`)
  return response.data
}

export async function approveGym(id) {
  const response = await api.post(`/admin/gyms/${id}/approve.json`)
  return response.data
}

export async function rejectGym(id) {
  const response = await api.post(`/admin/gyms/${id}/reject.json`)
  return response.data
}

export async function fetchModerationQueue(type = 'gym', params = {}) {
  const response = await api.get('/admin/gym_moderation.json', { params: { type, ...params } })
  return response.data
}

export async function approveModerationItem(type, id) {
  const response = await api.post('/admin/gym_moderation/approve.json', { type, id })
  return response.data
}

export async function rejectModerationItem(type, id) {
  const response = await api.post('/admin/gym_moderation/reject.json', { type, id })
  return response.data
}

export async function bulkApproveModerationItems(type, ids) {
  const response = await api.post('/admin/gym_moderation/bulk_approve.json', { type, ids })
  return response.data
}

export async function bulkRejectModerationItems(type, ids) {
  const response = await api.post('/admin/gym_moderation/bulk_reject.json', { type, ids })
  return response.data
}
